import { lockScreenScroll } from '../utils/treatment';
const sidebarFloating = document.querySelector('.sidebar-floating');

// FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FLOATING
export function sidebarFloatingBehavior(menu) {
  let menuSelected = document.querySelectorAll(menu);

  menuSelected.forEach((target) => {

    target.addEventListener('click', () => {

      let menuIcon = target.querySelector('i');
      let menuText = target.querySelector('span')

      sidebarFloating.classList.toggle('d-flex');
      lockScreenScroll();
    });
  });
}
